import React, { useCallback, useContext } from 'react';
import { IAppPanelProps } from './AppPanel.types';
import { Panel } from '@fluentui/react';
import { msGridUnit } from '../constants';
import { SuiteHeaderContext } from '../SuiteHeaderProvider';

export const AppPanel: React.FC<IAppPanelProps> = props => {
  const { localizationMap } = useContext(SuiteHeaderContext);
  const { isOpen, panelContent, headerText, type, id, onDismiss, onRenderFooterContent } = props;
  const closePanel = useCallback(() => {
    onDismiss(id, false);
  }, [id, onDismiss]);

  return (
    <Panel
      isLightDismiss
      isOpen={isOpen}
      type={type}
      onDismiss={closePanel}
      closeButtonAriaLabel={localizationMap.closePanelAriaLabel}
      styles={{
        root: {
          position: 'absolute',
          top: `${msGridUnit * 6}px`
        },
        content: {
          overflowY: 'auto'
        }
      }}
      isFooterAtBottom={true}
      onRenderFooterContent={onRenderFooterContent}
      headerText={headerText}
    >
      {panelContent}
    </Panel>
  );
};
